module.exports = __webpack_public_path__ + "img/ic_recording_stop.942c37e5.svg";